module.exports = __webpack_public_path__ + "img/面单例子.6d282ba6.png";